import React from 'react';

export default class Question extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <p className="answer-entry__text">How much money is shown?</p>
        <p>Type your answer, then press the enter (return) key to check.</p>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/money/question.js
 **/